const translations = {
  fr: {
    // Nav
    appName: "Qu'est-ce qu'on mange ?",
    home: "Accueil",
    generate: "Cuisiner",
    favorites: "Favoris",
    history: "Historique",
    pricing: "Abonnement",
    profile: "Profil",
    login: "Connexion",
    register: "Inscription",
    logout: "Déconnexion",
    // Home
    heroTitle: "Transformez vos ingrédients en recettes délicieuses",
    heroSubtitle: "L'IA culinaire qui crée des recettes personnalisées à partir de vos ingrédients ou du nom de plats connus",
    getStarted: "Commencer",
    popularIngredients: "Ingrédients populaires",
    recentRecipes: "Recettes récentes",
    // Generate
    generateTitle: "Générez votre recette",
    generateSubtitle: "Sélectionnez vos ingrédients et laissez l'IA créer une recette unique",
    enterIngredient: "Ajouter un ingrédient...",
    addIngredient: "Ajouter",
    selectedIngredients: "Ingrédients sélectionnés",
    generateRecipe: "Générer la recette",
    generating: "Génération en cours...",
    noIngredients: "Sélectionnez au moins un ingrédient",
    // Recipe
    prepTime: "Préparation",
    cookTime: "Cuisson",
    totalTime: "Temps total",
    servings: "Portions",
    ingredients: "Ingrédients",
    instructions: "Instructions",
    addToFavorites: "Ajouter aux favoris",
    removeFromFavorites: "Retirer des favoris",
    nutritionInfo: "Informations nutritionnelles",
    calories: "Calories",
    proteins: "Protéines",
    carbs: "Glucides",
    fats: "Lipides",
    dietaryTags: "Régime alimentaire",
    // Favorites
    favoritesTitle: "Mes recettes favorites",
    noFavorites: "Aucune recette favorite pour le moment",
    // History
    historyTitle: "Historique des recettes",
    noHistory: "Aucune recette générée pour le moment",
    // Pricing
    pricingTitle: "Abonnement Premium",
    pricingSubtitle: "Débloquez des recettes illimitées",
    monthly: "Mensuel",
    yearly: "Annuel",
    subscribe: "S'abonner",
    currentPlan: "Plan actuel",
    free: "Gratuit",
    premium: "Premium",
    premiumUntil: "Premium jusqu'au",
    freeRecipesUsed: "Recettes gratuites utilisées",
    of: "sur",
    // Auth
    email: "Email",
    password: "Mot de passe",
    name: "Nom complet",
    loginTitle: "Connexion",
    registerTitle: "Créer un compte",
    noAccount: "Pas de compte ?",
    hasAccount: "Déjà un compte ?",
    // Profile
    profileTitle: "Mon profil",
    memberSince: "Membre depuis",
    accountType: "Type de compte",
    // Legal
    privacyTitle: "Politique de confidentialité",
    termsTitle: "Conditions d'utilisation",
    helpTitle: "Aide et support",
    // Common
    loading: "Chargement...",
    error: "Une erreur est survenue",
    back: "Retour",
    save: "Enregistrer",
    delete: "Supprimer",
    viewRecipe: "Voir la recette",
    step: "Étape",
    cat_protein: "Protéines",
    cat_vegetable: "Légumes",
    cat_starch: "Féculents",
    cat_dairy: "Produits laitiers",
    lifetime: "À vie",
    lifetimeBadge: "À VIE",
    lifetimeSubtext: "Sans frais récurrents",
    uniquePayment: "unique",
    rememberMe: "Se souvenir de moi",
  },
  en: {
    appName: "What To Cook",
    home: "Home",
    generate: "Cook",
    favorites: "Favorites",
    history: "History",
    pricing: "Subscription",
    profile: "Profile",
    login: "Sign In",
    register: "Sign Up",
    logout: "Sign Out",
    heroTitle: "Transform your ingredients into delicious recipes",
    heroSubtitle: "AI-powered culinary assistant that creates personalized recipes from your ingredients or the name of known dishes",
    getStarted: "Get Started",
    popularIngredients: "Popular Ingredients",
    recentRecipes: "Recent Recipes",
    generateTitle: "Generate your recipe",
    generateSubtitle: "Select your ingredients and let AI create a unique recipe",
    enterIngredient: "Add an ingredient...",
    addIngredient: "Add",
    selectedIngredients: "Selected ingredients",
    generateRecipe: "Generate recipe",
    generating: "Generating...",
    noIngredients: "Select at least one ingredient",
    prepTime: "Prep Time",
    cookTime: "Cook Time",
    totalTime: "Total Time",
    servings: "Servings",
    ingredients: "Ingredients",
    instructions: "Instructions",
    addToFavorites: "Add to favorites",
    removeFromFavorites: "Remove from favorites",
    nutritionInfo: "Nutritional Information",
    calories: "Calories",
    proteins: "Proteins",
    carbs: "Carbs",
    fats: "Fats",
    dietaryTags: "Dietary Tags",
    favoritesTitle: "My favorite recipes",
    noFavorites: "No favorite recipes yet",
    historyTitle: "Recipe history",
    noHistory: "No recipes generated yet",
    pricingTitle: "Premium Subscription",
    pricingSubtitle: "Unlock unlimited recipes",
    monthly: "Monthly",
    yearly: "Yearly",
    subscribe: "Subscribe",
    currentPlan: "Current plan",
    free: "Free",
    premium: "Premium",
    premiumUntil: "Premium until",
    freeRecipesUsed: "Free recipes used",
    of: "of",
    email: "Email",
    password: "Password",
    name: "Full name",
    loginTitle: "Sign In",
    registerTitle: "Create an account",
    noAccount: "No account?",
    hasAccount: "Already have an account?",
    profileTitle: "My Profile",
    memberSince: "Member since",
    accountType: "Account type",
    privacyTitle: "Privacy Policy",
    termsTitle: "Terms of Use",
    helpTitle: "Help & Support",
    loading: "Loading...",
    error: "An error occurred",
    back: "Back",
    save: "Save",
    delete: "Delete",
    viewRecipe: "View recipe",
    step: "Step",
    cat_protein: "Protein",
    cat_vegetable: "Vegetable",
    cat_starch: "Starch",
    cat_dairy: "Dairy",
    lifetime: "Lifetime Access",
    lifetimeBadge: "LIFETIME",
    lifetimeSubtext: "No recurring fees",
    uniquePayment: "one-time",
    rememberMe: "Remember me",
  },
  es: {
    appName: "\u00bfQu\u00e9 cocinar?",
    home: "Inicio",
    generate: "Cocinar",
    favorites: "Favoritos",
    history: "Historial",
    pricing: "Suscripcion",
    profile: "Perfil",
    login: "Iniciar sesion",
    register: "Registrarse",
    logout: "Cerrar sesion",
    heroTitle: "Transforma tus ingredientes en recetas deliciosas",
    heroSubtitle: "Asistente culinario con IA que crea recetas personalizadas a partir de tus ingredientes o del nombre de platos conocidos",
    getStarted: "Comenzar",
    popularIngredients: "Ingredientes populares",
    recentRecipes: "Recetas recientes",
    generateTitle: "Genera tu receta",
    generateSubtitle: "Selecciona tus ingredientes y deja que la IA cree una receta unica",
    enterIngredient: "Agregar un ingrediente...",
    addIngredient: "Agregar",
    selectedIngredients: "Ingredientes seleccionados",
    generateRecipe: "Generar receta",
    generating: "Generando...",
    noIngredients: "Selecciona al menos un ingrediente",
    prepTime: "Preparacion",
    cookTime: "Coccion",
    totalTime: "Tiempo total",
    servings: "Porciones",
    ingredients: "Ingredientes",
    instructions: "Instrucciones",
    addToFavorites: "Agregar a favoritos",
    removeFromFavorites: "Quitar de favoritos",
    nutritionInfo: "Informacion nutricional",
    calories: "Calorias",
    proteins: "Proteinas",
    carbs: "Carbohidratos",
    fats: "Grasas",
    dietaryTags: "Etiquetas dieteticas",
    favoritesTitle: "Mis recetas favoritas",
    noFavorites: "Aun no tienes recetas favoritas",
    historyTitle: "Historial de recetas",
    noHistory: "Aun no has generado recetas",
    pricingTitle: "Suscripcion Premium",
    pricingSubtitle: "Desbloquea recetas ilimitadas",
    monthly: "Mensual",
    yearly: "Anual",
    subscribe: "Suscribirse",
    currentPlan: "Plan actual",
    free: "Gratis",
    premium: "Premium",
    premiumUntil: "Premium hasta",
    freeRecipesUsed: "Recetas gratuitas utilizadas",
    of: "de",
    email: "Correo electronico",
    password: "Contrasena",
    name: "Nombre completo",
    loginTitle: "Iniciar sesion",
    registerTitle: "Crear cuenta",
    noAccount: "No tienes cuenta?",
    hasAccount: "Ya tienes cuenta?",
    profileTitle: "Mi Perfil",
    memberSince: "Miembro desde",
    accountType: "Tipo de cuenta",
    privacyTitle: "Politica de privacidad",
    termsTitle: "Condiciones de uso",
    helpTitle: "Ayuda y soporte",
    loading: "Cargando...",
    error: "Ocurrio un error",
    back: "Volver",
    save: "Guardar",
    delete: "Eliminar",
    viewRecipe: "Ver receta",
    step: "Paso",
    cat_protein: "Proteínas",
    cat_vegetable: "Verduras",
    cat_starch: "Almidones",
    cat_dairy: "Lácteos",
    lifetime: "Acceso de por vida",
    lifetimeBadge: "DE POR VIDA",
    lifetimeSubtext: "Sin cargos recurrentes",
    uniquePayment: "único",
    rememberMe: "Recuérdame",
  },
  de: {
    appName: "Was kochen wir?",
    home: "Startseite",
    generate: "Kochen",
    favorites: "Favoriten",
    history: "Verlauf",
    pricing: "Abonnement",
    profile: "Profil",
    login: "Anmelden",
    register: "Registrieren",
    logout: "Abmelden",
    heroTitle: "Verwandle deine Zutaten in kostliche Rezepte",
    heroSubtitle: "KI-gestutzter Kochassistent der personalisierte Rezepte aus deinen Zutaten oder bekannten Gerichtnamen erstellt",
    getStarted: "Loslegen",
    popularIngredients: "Beliebte Zutaten",
    recentRecipes: "Neueste Rezepte",
    generateTitle: "Erstelle dein Rezept",
    generateSubtitle: "Wahle deine Zutaten und lass die KI ein einzigartiges Rezept erstellen",
    enterIngredient: "Zutat hinzufugen...",
    addIngredient: "Hinzufugen",
    selectedIngredients: "Ausgewahlte Zutaten",
    generateRecipe: "Rezept generieren",
    generating: "Wird generiert...",
    noIngredients: "Wahle mindestens eine Zutat",
    prepTime: "Vorbereitungszeit",
    cookTime: "Kochzeit",
    totalTime: "Gesamtzeit",
    servings: "Portionen",
    ingredients: "Zutaten",
    instructions: "Anleitung",
    addToFavorites: "Zu Favoriten hinzufugen",
    removeFromFavorites: "Aus Favoriten entfernen",
    nutritionInfo: "Nahrwertinformationen",
    calories: "Kalorien",
    proteins: "Proteine",
    carbs: "Kohlenhydrate",
    fats: "Fette",
    dietaryTags: "Ernahrungstags",
    favoritesTitle: "Meine Lieblingsrezepte",
    noFavorites: "Noch keine Lieblingsrezepte",
    historyTitle: "Rezeptverlauf",
    noHistory: "Noch keine Rezepte generiert",
    pricingTitle: "Premium-Abonnement",
    pricingSubtitle: "Unbegrenzte Rezepte freischalten",
    monthly: "Monatlich",
    yearly: "Jahrlich",
    subscribe: "Abonnieren",
    currentPlan: "Aktueller Plan",
    free: "Kostenlos",
    premium: "Premium",
    premiumUntil: "Premium bis",
    freeRecipesUsed: "Kostenlose Rezepte genutzt",
    of: "von",
    email: "E-Mail",
    password: "Passwort",
    name: "Vollstandiger Name",
    loginTitle: "Anmelden",
    registerTitle: "Konto erstellen",
    noAccount: "Kein Konto?",
    hasAccount: "Bereits ein Konto?",
    profileTitle: "Mein Profil",
    memberSince: "Mitglied seit",
    accountType: "Kontotyp",
    privacyTitle: "Datenschutzrichtlinie",
    termsTitle: "Nutzungsbedingungen",
    helpTitle: "Hilfe & Support",
    loading: "Laden...",
    error: "Ein Fehler ist aufgetreten",
    back: "Zuruck",
    save: "Speichern",
    delete: "Loschen",
    viewRecipe: "Rezept anzeigen",
    step: "Schritt",
    cat_protein: "Eiweiß",
    cat_vegetable: "Gemüse",
    cat_starch: "Stärke",
    cat_dairy: "Milchprodukte",
    lifetime: "Lebenslanger Zugang",
    lifetimeBadge: "LEBENSLANG",
    lifetimeSubtext: "Keine wiederkehrenden Gebühren",
    uniquePayment: "einmalig",
    rememberMe: "Angemeldet bleiben",
  },
  pt: {
    appName: "O que cozinhar?",
    home: "Inicio",
    generate: "Cozinhar",
    favorites: "Favoritos",
    history: "Historico",
    pricing: "Assinatura",
    profile: "Perfil",
    login: "Entrar",
    register: "Cadastrar",
    logout: "Sair",
    heroTitle: "Transforme seus ingredientes em receitas deliciosas",
    heroSubtitle: "Assistente culinario com IA que cria receitas personalizadas a partir dos seus ingredientes ou do nome de pratos conhecidos",
    getStarted: "Comecar",
    popularIngredients: "Ingredientes populares",
    recentRecipes: "Receitas recentes",
    generateTitle: "Gere sua receita",
    generateSubtitle: "Selecione seus ingredientes e deixe a IA criar uma receita unica",
    enterIngredient: "Adicionar um ingrediente...",
    addIngredient: "Adicionar",
    selectedIngredients: "Ingredientes selecionados",
    generateRecipe: "Gerar receita",
    generating: "Gerando...",
    noIngredients: "Selecione pelo menos um ingrediente",
    prepTime: "Preparo",
    cookTime: "Cozimento",
    totalTime: "Tempo total",
    servings: "Porcoes",
    ingredients: "Ingredientes",
    instructions: "Instrucoes",
    addToFavorites: "Adicionar aos favoritos",
    removeFromFavorites: "Remover dos favoritos",
    nutritionInfo: "Informacoes nutricionais",
    calories: "Calorias",
    proteins: "Proteinas",
    carbs: "Carboidratos",
    fats: "Gorduras",
    dietaryTags: "Tags dieteticas",
    favoritesTitle: "Minhas receitas favoritas",
    noFavorites: "Nenhuma receita favorita ainda",
    historyTitle: "Historico de receitas",
    noHistory: "Nenhuma receita gerada ainda",
    pricingTitle: "Assinatura Premium",
    pricingSubtitle: "Desbloqueie receitas ilimitadas",
    monthly: "Mensal",
    yearly: "Anual",
    subscribe: "Assinar",
    currentPlan: "Plano atual",
    free: "Gratis",
    premium: "Premium",
    premiumUntil: "Premium ate",
    freeRecipesUsed: "Receitas gratuitas usadas",
    of: "de",
    email: "E-mail",
    password: "Senha",
    name: "Nome completo",
    loginTitle: "Entrar",
    registerTitle: "Criar conta",
    noAccount: "Nao tem conta?",
    hasAccount: "Ja tem conta?",
    profileTitle: "Meu Perfil",
    memberSince: "Membro desde",
    accountType: "Tipo de conta",
    privacyTitle: "Politica de privacidade",
    termsTitle: "Termos de uso",
    helpTitle: "Ajuda e suporte",
    loading: "Carregando...",
    error: "Ocorreu um erro",
    back: "Voltar",
    save: "Salvar",
    delete: "Excluir",
    viewRecipe: "Ver receita",
    step: "Passo",
    cat_protein: "Proteínas",
    cat_vegetable: "Legumes",
    cat_starch: "Amidos",
    cat_dairy: "Laticínios",
    lifetime: "Acesso Vitalício",
    lifetimeBadge: "VITALÍCIO",
    lifetimeSubtext: "Sem taxas recorrentes",
    uniquePayment: "único",
    rememberMe: "Lembrar-me",
  },
  it: {
    appName: "Cosa cucinare?",
    home: "Home",
    generate: "Cucinare",
    favorites: "Preferiti",
    history: "Cronologia",
    pricing: "Abbonamento",
    profile: "Profilo",
    login: "Accedi",
    register: "Registrati",
    logout: "Esci",
    heroTitle: "Trasforma i tuoi ingredienti in ricette deliziose",
    heroSubtitle: "Assistente culinario con IA che crea ricette personalizzate dai tuoi ingredienti o dal nome di piatti conosciuti",
    getStarted: "Inizia",
    popularIngredients: "Ingredienti popolari",
    recentRecipes: "Ricette recenti",
    generateTitle: "Genera la tua ricetta",
    generateSubtitle: "Seleziona i tuoi ingredienti e lascia che l'IA crei una ricetta unica",
    enterIngredient: "Aggiungi un ingrediente...",
    addIngredient: "Aggiungi",
    selectedIngredients: "Ingredienti selezionati",
    generateRecipe: "Genera ricetta",
    generating: "Generazione in corso...",
    noIngredients: "Seleziona almeno un ingrediente",
    prepTime: "Preparazione",
    cookTime: "Cottura",
    totalTime: "Tempo totale",
    servings: "Porzioni",
    ingredients: "Ingredienti",
    instructions: "Istruzioni",
    addToFavorites: "Aggiungi ai preferiti",
    removeFromFavorites: "Rimuovi dai preferiti",
    nutritionInfo: "Informazioni nutrizionali",
    calories: "Calorie",
    proteins: "Proteine",
    carbs: "Carboidrati",
    fats: "Grassi",
    dietaryTags: "Tag dietetici",
    favoritesTitle: "Le mie ricette preferite",
    noFavorites: "Nessuna ricetta preferita ancora",
    historyTitle: "Cronologia ricette",
    noHistory: "Nessuna ricetta generata ancora",
    pricingTitle: "Abbonamento Premium",
    pricingSubtitle: "Sblocca ricette illimitate",
    monthly: "Mensile",
    yearly: "Annuale",
    subscribe: "Abbonati",
    currentPlan: "Piano attuale",
    free: "Gratuito",
    premium: "Premium",
    premiumUntil: "Premium fino al",
    freeRecipesUsed: "Ricette gratuite utilizzate",
    of: "di",
    email: "Email",
    password: "Password",
    name: "Nome completo",
    loginTitle: "Accedi",
    registerTitle: "Crea un account",
    noAccount: "Non hai un account?",
    hasAccount: "Hai gia un account?",
    profileTitle: "Il mio Profilo",
    memberSince: "Membro dal",
    accountType: "Tipo di account",
    privacyTitle: "Informativa sulla privacy",
    termsTitle: "Condizioni di utilizzo",
    helpTitle: "Aiuto e supporto",
    loading: "Caricamento...",
    error: "Si e verificato un errore",
    back: "Indietro",
    save: "Salva",
    delete: "Elimina",
    viewRecipe: "Vedi ricetta",
    step: "Passo",
    cat_protein: "Proteine",
    cat_vegetable: "Verdure",
    cat_starch: "Amidi",
    cat_dairy: "Latticini",
    lifetime: "Accesso a vita",
    lifetimeBadge: "A VITA",
    lifetimeSubtext: "Nessun costo ricorrente",
    uniquePayment: "unico",
    rememberMe: "Ricordami",
  },
};

const langNames = {
  fr: "Fran\u00e7ais",
  en: "English",
  es: "Espa\u00f1ol",
  de: "Deutsch",
  pt: "Portugu\u00eas",
  it: "Italiano",
};

const langFlags = {
  fr: "FR",
  en: "EN",
  es: "ES",
  de: "DE",
  pt: "PT",
  it: "IT",
};

export function detectLanguage() {
  const stored = localStorage.getItem("app_language");
  if (stored && translations[stored]) return stored;
  const browserLang = navigator.language?.split("-")[0];
  if (browserLang && translations[browserLang]) return browserLang;
  return "fr";
}

export function t(key, lang) {
  return translations[lang]?.[key] || translations.fr[key] || key;
}

export { translations, langNames, langFlags };
